var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnnecessaryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.131,
    height: 15.861,
    viewBox: "0 0 11.131 15.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13456",
    "data-name": "Group 13456",
    transform: "translate(221.812 -0.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11187",
    "data-name": "Path 11187",
    d: "M-193.63,6.836a4.915,4.915,0,0,0-1.346-3.244,4.844,4.844,0,0,0-.9-.735,4.653,4.653,0,0,0-2.222-.723q-.186-.011-.372-.011a5.41,5.41,0,0,0-.833.061,4.25,4.25,0,0,0-1.432.471c-.071.036-.139.075-.2.11a.246.246,0,0,0,.079.087l.426.3a.222.222,0,0,0,.042.023l1.481.614.7.562.176.49.182.54a.22.22,0,0,0,.11.129l1.581.737.024.01.843.275.021.006.955.215c.1.206.4.733.6,1.126A8.7,8.7,0,0,0-193.63,6.836Z",
    transform: "translate(-17.552 -1)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11188",
    "data-name": "Path 11188",
    d: "M-212.687,17.123l-.473-.108-.022-.006-1.079-.36-.02-.008-2.134-.936a.243.243,0,0,1-.12-.12l-.69-1.5-.285-.23-1.473-.612-.588-.306a4.829,4.829,0,0,0-1.714,3.174,4.567,4.567,0,0,0,.233,2.023,10.314,10.314,0,0,0,1.271,2.216l.02.03a6.107,6.107,0,0,1,1.219,2.519c.038.427.056.856.054,1.285h3.941q0-.642.054-1.281a5.582,5.582,0,0,1,1.088-2.334l.06-.088a15.129,15.129,0,0,0,1.155-1.872c.037-.084.07-.162.1-.24C-212.318,17.872-212.535,17.4-212.687,17.123Z",
    transform: "translate(0 -9.519)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11189",
    "data-name": "Path 11189",
    d: "M-192.981,60.216V55.609l-1.729-1.729",
    transform: "translate(-23.411 -45.549)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11190",
    "data-name": "Path 11190",
    d: "M-180.3,60.216V55.609l1.729-1.729",
    transform: "translate(-36.096 -45.549)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_630",
    "data-name": "Line 630",
    x2: 3.96,
    transform: "translate(-218.491 15.326)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_631",
    "data-name": "Line 631",
    x2: 2.238,
    transform: "translate(-217.631 15.985)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnnecessaryIcon);
export default __webpack_public_path__ + "static/media/unnecessaryIcon.b556d3c09c0c0f46ec774924567fd2d1.svg";
export { ForwardRef as ReactComponent };